module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-wrap"
  }, [_c('div', {
    staticClass: "block-header clearfix"
  }, [_c('ul', {
    staticClass: "nav flex-column small-bar"
  }, [_c('li', [_c('div', {
    staticClass: "pointer small-item",
    class: {
      active: _vm.path_name == 'members'
    },
    on: {
      "click": function($event) {
        _vm.goMembers()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("成員設定")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.user.permission == 'admin') ? _c('div', {
    staticClass: "pointer small-item",
    class: {
      active: _vm.path_name == 'company'
    },
    on: {
      "click": function($event) {
        _vm.goCompany()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info"
  }), _vm._v(" "), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("公司設定")])]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.user.permission == 'admin') ? _c('div', {
    staticClass: "pointer small-item",
    class: {
      active: _vm.path_name == 'set_stages'
    },
    on: {
      "click": function($event) {
        _vm.goStages()
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-widgets"
  }), _vm._v(" "), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("階段設定")])]) : _vm._e()]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "pointer small-item",
    class: {
      active: _vm.path_name == 'activity_categories'
    },
    on: {
      "click": function($event) {
        _vm.goActivitiesCategory()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-calendar-plus"
  }), _vm._v(" "), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("任務設定")])])]), _vm._v(" "), (_vm.user.permission == 'admin') ? _c('li', [_c('hr')]) : _vm._e(), _vm._v(" "), _c('li', [(_vm.user.permission == 'admin') ? _c('div', {
    staticClass: "pointer small-item",
    class: {
      active: _vm.path_name == 'credit_card_binding'
    },
    on: {
      "click": function($event) {
        _vm.goCreditCard()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-credit-card"
  }), _vm._v(" "), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("方案選擇與信用卡")])]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.user.permission == 'admin') ? _c('div', {
    staticClass: "pointer small-item",
    class: {
      active: _vm.path_name == 'bills'
    },
    on: {
      "click": function($event) {
        _vm.goBills()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-invoice-dollar"
  }), _vm._v(" "), _c('span', {
    staticClass: "list-label"
  }, [_vm._v("帳單一覽")])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-654ddf57","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/SmallBar.vue
// module id = 693
// module chunks = 4